<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="table-responsive">
    <b-table
      class="table table-responsive table-responsive-sm table-responsive-md
                   table-responsive-lg table-responsive-xl"
      fixed
      show-empty
      responsive
      tbody-tr-class="one-line-td-table"
      :busy="loading"
      :fields="fields"
      :items="canRead(access) ? data : []">
      <template v-slot:table-busy="">
        <div class="text-center text-danger my-2">
          <wave-loader>Loading...</wave-loader>
        </div>
      </template>
      <template v-slot:head(devcStatus)="data">
        <div class="text-center">
          {{data.label}}
        </div>
      </template>
      <template v-slot:cell(action)="data">
        <div class="text-center">
          <role-edit
            :access="'master_role'"
            :role="data.item"
            :viewTo="{ name: 'RoleDetail', params: { id: data.item.roleId } }"
            @onDeleteClicked="onActionDelete"/>
        </div>
      </template>
      <template v-slot:cell(devcStatus)="data">
        <div class="text-center">
          {{normalizeStatus(data.value)}}
        </div>
      </template>
      <template v-slot:cell(roleScope)="data">
        <div class="text-center">
          <b-badge v-if="data.value === 'internal'" variant="primary">Internal</b-badge>
          <b-badge v-else-if="data.value === 'client'" variant="info">Client</b-badge>
          <span v-else>-</span>
        </div>
      </template>
    </b-table>
    <b-pagination
      v-model="pagination.current"
      :per-page="pagination.pageSize"
      :total-rows="pagination.totalSize"
      @change="onPaginationChanged"
    ></b-pagination>
  </div>
</template>

<script>
import RoleEdit from './Edit';

export default {
  name: 'RoleList',
  components: { RoleEdit },
  props: ['access', 'data', 'group', 'loading', 'pagination'],
  data() {
    return {
      fields: [
        {
          key: 'roleName',
          label: 'Role Name',
          class: 'text-left',
        },
        {
          key: 'roleScope',
          label: 'Scope',
          class: 'text-center',
          thStyle: { width: '1%', whiteSpace: 'nowrap' },
        },
        {
          key: 'action',
          label: '',
        },
      ],
    };
  },
  methods: {
    normalizeStatus(v) {
      if (v === '1') {
        return 'Approved';
      }

      return 'Not Approved';
    },
    onPaginationChanged(page) {
      this.$emit('onPageChanged', page);
    },
    onActionDelete(data) {
      this.$emit('onActionDelete', data);
    },
  },
};
</script>

<style scoped>

</style>
